export function isAppRouteRoute(route: string): boolean {
  return route.endsWith('/route')
}
